import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const ExpenseBarChart = ({ fuelData, serviceData, otherData,unit }) => {
    // Extract months for labels
    const labels = fuelData?.map(item => item.month);

    // Prepare data for each category
    const fuelTotals = fuelData?.map(item => item.total);
    const serviceTotals = serviceData?.map(item => item.total);
    const otherTotals = otherData?.map(item => item.total);

    const data = {
        labels,
        datasets: [
            {
                label: 'Fuel',
                data: fuelTotals,
                backgroundColor: 'rgba(75, 192, 192, 0.6)', // Greenish
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            },
            {
                label: 'Service',
                data: serviceTotals,
                backgroundColor: 'rgba(54, 162, 235, 0.6)', // Blue
                borderColor: 'rgba(54, 162, 235, 1)',
                borderWidth: 1,
            },
            {
                label: 'Other',
                data: otherTotals,
                backgroundColor: 'rgba(153, 102, 255, 0.6)', // Purple/Gray
                borderColor: 'rgba(153, 102, 255, 1)',
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Monthly Expenses (YTD)',
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: `Total (${unit})`,
                },
            },
            x: {
                title: {
                    display: true,
                    text: 'Month',
                },
                grid: {
                    drawOnChartArea: false
                }
            },
        },
        barPercentage: 0.6,       // Default is 0.9
        categoryPercentage: 0.7,
    };

    return <Bar className='min-h-[300px]' data={data} options={options} />;
};

export default ExpenseBarChart;